// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Counter_componentWrapper__dzp3j","input":"Counter_input__vEdRt","button":"Counter_button__meuuy"};